window.shopUrl = '';
window.routes = {
  cart_add_url: '',
  cart_change_url: '',
  cart_update_url: ''
};

window.cartStrings = {
  error: 'There was an error while updating your cart. Please try again.',
  quantityError: 'You can only add [quantity] of this item to your cart.'
};

window.variantStrings = {
  unavailable: 'Unavailable',
  addToCart: 'Add to cart',
  soldOut: 'Sold out',
  addSubscriptionToCart: 'Add subscription to cart'
};

window.validationStrings = {
  invalidEmail: 'Please enter a valid email address'
};

window.accessibilityStrings = {
  recipientFormExpanded: 'Gift card recipient form expanded',
  recipientFormCollapsed: 'Gift card recipient form collapsed'
};

// Recharge configuration
window.STOREFRONT_ACCESS_TOKEN = 'strfnt_3157b7596c9723441041d0de5ed40203dcf0ff723ddcb12ab69c6e26ac6836a9';
window.SHOP_PERMANENT_DOMAIN = '';

// Gorgias configuration
!function(_){
  _.SHOPIFY_PERMANENT_DOMAIN = "";
  _.SHOPIFY_CUSTOMER_ID = "";
  _.SHOPIFY_CUSTOMER_EMAIL = "";
}(window || {});
